import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useState } from "react";
import { Modal, Table, Form } from "react-bootstrap";
import useDebounce from "../../utils/hooks";
import queryString from "query-string";
import { useQuery } from "react-query";
import { format } from "date-fns";
import Datetime from "react-datetime";
import moment from "moment";
import { useAuth } from "../../hooks/useAuth";
import { customerFullName } from "../../utils/helpers";

export default function AllocatedListModal({
  setShowAllocatedListModal,
  handleSelectedAllocation,
}) {
  const { backendUrl } = useAuth();
  const [queryParams, setQueryParams] = useState({ q: "", date: "" });
  const debouncedqueryParams = useDebounce(queryParams, 500);

  const getAllocations = async debouncedqueryParams => {
    const params = {
      ...debouncedqueryParams,
      date: moment.isMoment(debouncedqueryParams.date)
        ? debouncedqueryParams.date.format("YYYY-MM-DD")
        : "",
    };
    let response = await fetch(
      `${backendUrl}/api/invoice/atc-allocations?${queryString.stringify(
        params
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();
    return data;
  };

  const { data = { allocations: [] } } = useQuery(
    ["ATC_ALLOCATIONS", debouncedqueryParams],
    () => getAllocations(debouncedqueryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  return (
    <Modal
      show={true}
      onHide={() => setShowAllocatedListModal(false)}
      backdropClassName={`global-backdrop`}
      centered={true}
      animation={false}
      enforceFocus={false}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1 className="h5">Pick from Allocated List</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="search-area d-flex justify-content-between align-items-center gap-3 w-100 px-3 mb-4">
          <div className="global-search-area flex-grow-1">
            <MagnifyIcon />
            <input
              className="form-control search-input"
              name="q"
              value={queryParams.q}
              onChange={e =>
                setQueryParams({ ...queryParams, q: e.target.value })
              }
              placeholder="Search Transaction ID..."
              autoFocus
              autoComplete="off"
            />
          </div>

          <Form.Group className="d-flex align-items-center gap-2">
            <Datetime
              dateFormat="MMM DD, YYYY"
              timeFormat={false}
              closeOnSelect
              value={queryParams.date}
              onChange={date => setQueryParams({ ...queryParams, date })}
              inputProps={{
                className: "date-input form-control",
                placeholder: "Filter by date",
              }}
            />
            {queryParams.date && (
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setQueryParams({ ...queryParams, date: "" })}
              >
                ✕
              </button>
            )}
          </Form.Group>
        </div>

        <div className="content px-3 pb-4 pe-2">
          <Table
            borderless
            striped
            responsive
            className="product-table text-nowrap"
          >
            <thead className="sticky border-bottom">
              <tr>
                <th>Customer</th>
                <th>Date</th>
                <th>Items</th>
                <th>Qty</th>
                <th>Transaction ID</th>
              </tr>
            </thead>

            <tbody className="blue-hover">
              {data.allocations.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center py-3">
                    No allocations found
                  </td>
                </tr>
              ) : (
                data.allocations.map((el, index) => (
                  <tr
                    key={index}
                    onClick={() => handleSelectedAllocation(el)}
                    className="p-cursor"
                  >
                    <td>
                      {el.customers.map(customerFullName).join(", ")}
                    </td>
                    <td>
                      {el.Date_Log
                        ? format(new Date(el.Date_Log), "MMM dd, yyyy")
                        : ""}
                    </td>
                    <td>{el.items.length}</td>
                    <td>
                      {el.items.reduce(
                        (sum, item) => sum + Number(item.QTY || 0),
                        0
                      )}
                    </td>
                    <td>{el.TransactionID}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
}
